import { render, staticRenderFns } from "./new-system-config-modal.vue?vue&type=template&id=cab37932&scoped=true"
import script from "./new-system-config-modal.vue?vue&type=script&lang=js"
export * from "./new-system-config-modal.vue?vue&type=script&lang=js"
import style0 from "./new-system-config-modal.vue?vue&type=style&index=0&id=cab37932&prod&scoped=true&lang=css"
import style1 from "./new-system-config-modal.vue?vue&type=style&index=1&id=cab37932&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab37932",
  null
  
)

export default component.exports